
import VueSlickCarousel from 'vue-slick-carousel'
import PaginationCommon from '../../components/element-ui/Pagination'
import SimpleSearchBlogElement from '../../components/blog/single'
import { INDEX_SET_LOADING, GET_LIST_BLOGS, GET_LIST_CATEGORY_BLOGS } from '../../store/store.const'
export default {
  name: 'ConsultingBlog',
  components: { VueSlickCarousel, PaginationCommon, SimpleSearchBlogElement },
  data() {
    return {
      listCategories: [],
      slugCategory: '',
      slideSetting: {
        'dots': false,
        'focusOnSelect': false,
        'infinite': false,
        'initialSlide': 0,
        'speed': 500,
        'slidesToShow': 8,
        'slidesToScroll': 1,
        'swipeToSlide': true,
        'responsive': [
          {
            'breakpoint': 1270,
            'settings': {
              'slidesToShow': 5,
              'slidesToScroll': 6
            }
          },
          {
            'breakpoint': 1080,
            'settings': {
              'slidesToShow': 5,
              'slidesToScroll': 6
            }
          },
          {
            'breakpoint': 820,
            'settings': {
              'slidesToShow': 4,
              'slidesToScroll': 5
            }
          },
          {
            'breakpoint': 720,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 4
            }
          },
          {
            'breakpoint': 600,
            'settings': {
              'slidesToShow': 3,
              'slidesToScroll': 3
            }
          },
          {
            'breakpoint': 480,
            'settings': {
              'slidesToShow': 2,
              'slidesToScroll': 2
            }
          }
        ]
      },
      typeSort: 'created_at',
      listSort: [
        {
          value: 'created_at',
          label: this.$t('sort.new')
        },
        {
          value: 'total_view',
          label: this.$t('sort.most_view')
        }
      ],
      total: 0,
      page: 1,
      last_page: 1,
      per_page: 12,
      blogs: [],
      fullscreenLoading: false,
      viewProduct: 5
    }
  },
  head() {
    const tags = {}
    tags.title = this.$t('seo.blog.title')
    tags.meta = [
      { hid: 'title', name: 'title', content: this.$t('seo.blog.title') },
      { hid: 'description', name: 'description', content: this.$t('seo.blog.description') },
      { hid: 'keywords', name: 'keywords', content: this.$t('seo.blog.keywords') },
      { hid: 'twitter:card', name: 'twitter:card', content: 'summary' },
      { hid: 'twitter:title', name: 'twitter:title', content: this.$t('seo.blog.title') },
      { hid: 'twitter:description', name: 'twitter:description', content: this.$t('seo.blog.description') },
      { hid: 'twitter:keywords', name: 'twitter:keywords', content: this.$t('seo.blog.keywords') },
      { hid: 'og:type', property: 'og:type', content: 'website' },
      { hid: 'og:title', property: 'og:title', content: this.$t('seo.blog.title') },
      { hid: 'og:description', property: 'og:description', content: this.$t('seo.blog.description') },
      { hid: 'og:keywords', property: 'og:keywords', content: this.$t('seo.blog.keywords') }
    ]

    return tags
  },
  watch: {
    typeSort() {
      this.getListBlogs()
    },
    viewProduct() {
      if (this.viewProduct > this.blogs.length) {
        this.per_page += 5
        this.getListBlogs()
      }
    }
  },
  created() {
    this.fetchDataCategory()
    this.getListBlogs()
  },
  methods: {
    async fetchDataCategory() {
      try {
        const category = await this.$store.dispatch(GET_LIST_CATEGORY_BLOGS)
        let all_blogs = 0
        category.data.forEach(blog => {
          all_blogs += blog.blogs_count
        })
        category.data.unshift({
          id: 0,
          name: 'Tất cả',
          slug: '',
          blogs_count: all_blogs
        })
        this.listCategories = category.data
      } catch (e) {
        console.log(e)
      }
    },
    async changePaginate(page) {
      this.page = page
      await this.getListBlogs()
    },
    getListBlogsCategory(value) {
      this.slugCategory = value
      this.getListBlogs()
    },
    async getListBlogs() {
      try {
        await this.$store.commit(INDEX_SET_LOADING, true)
        let search = {
          page: this.page,
          per_page: this.per_page,
          'orders[0][key]': this.typeSort,
          'orders[0][dir]': 'desc'
        }
        if (!this.typeSort) {
          search = {
            page: this.page,
            per_page: this.per_page
          }
        }
        if (this.slugCategory) {
          search.slug = this.slugCategory
        }
        const blogs = await this.$store.dispatch(GET_LIST_BLOGS, { filters: search })
        if (!this.$device.isMobile) {
          this.blogs = blogs.data.data
          this.page = blogs.data.current_page
          this.last_page = blogs.data.total_page
          this.total = blogs.data.total
        } else {
          this.blogs = blogs.data.data
          this.page = blogs.data.current_page
          this.last_page = blogs.data.total_page
          this.total = blogs.data.total
        }
      } catch (e) {
        console.log(e)
      }
      await this.$store.commit(INDEX_SET_LOADING, false)
    }
  }

}
